import { computed } from "vue";
import { useSecurityGapsStore } from "@/_store/security-gaps.module.ts";
import type { SecurityGapItem } from "@/_store/security-gaps.module.ts";

export const useSecurityGapsNavigation = () => {
  const securityGapsStore = useSecurityGapsStore();

  const setNavigationFromSecurityGaps = (securityGapItem: SecurityGapItem, workspaceId: string) => {
    securityGapsStore.setNavigationFromSecurityGaps(securityGapItem, workspaceId);
  };

  const clearNavigationState = () => {
    securityGapsStore.clearNavigationState();
  };

  const goBackToSecurityGaps = async () => {
    await securityGapsStore.goBackToSecurityGaps();
  };

  const shouldShowGoBackButton = () => {
    return securityGapsStore.navigation.showBackButton;
  };

  return {
    navigationState: computed(() => securityGapsStore.navigation),
    setNavigationFromSecurityGaps,
    clearNavigationState,
    goBackToSecurityGaps,
    shouldShowGoBackButton,
  };
};
